import { render, staticRenderFns } from "./ModalExport.vue?vue&type=template&id=246d6f12&"
import script from "./ModalExport.vue?vue&type=script&lang=js&"
export * from "./ModalExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports